// extracted by mini-css-extract-plugin
export const container = "sparkles-module--container--1WGk_";
export const animate = "sparkles-module--animate--IN4-S";
export const fade = "sparkles-module--fade--1FmuP";